import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Layout } from "@/components/Layout";
import { ScrollToTop } from "@/components/ScrollToTop";
import HomePage from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Activities from "@/pages/Activities";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Enquiry from "@/pages/Enquiry";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/enquiry" element={<Enquiry />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
